import React, { FC, useContext } from 'react';

import { Select } from '@gravity-ui/uikit';
import { Field } from 'client/blocks/form/Field/Field';
import { Context as SnapshotContext } from 'client/context/snapshotContext';
import { AliceAgentAppCategory } from 'client/types';

export const getAliceAgentAppCategoryTitle = (category: AliceAgentAppCategory, lang: string): string =>
    category.title[lang] || category.title.ru || category.title.en || category.name;

interface Props {
    value: string;
    onUpdate: (value: string) => void;
    disabled?: boolean;
    error?: string;
    fieldTitle: string;
    placeholder: string;
    className?: string;
}

/**
 * Optional Alice Apps Store category select. Options come from `/snapshot` via
 * `aliceAgentAppCategories`. The backend cannot clear an assignment, so the control has no
 * empty option — leave it unselected to keep the draft without a category.
 */
export const AliceAgentAppCategoryField: FC<Props> = ({
    value,
    onUpdate,
    disabled,
    error,
    fieldTitle,
    placeholder,
    className,
}) => {
    const { snapshot } = useContext(SnapshotContext);
    const categories = snapshot.aliceAgentAppCategories ?? [];
    const lang = String(__appConfig.lang ?? 'ru');

    return (
        <Field fieldTitle={fieldTitle} error={error}>
            <Select
                className={className}
                disabled={disabled}
                onUpdate={(next) => onUpdate(next[0] ?? '')}
                options={categories.map((category) => ({
                    value: category.name,
                    content: getAliceAgentAppCategoryTitle(category, lang),
                }))}
                placeholder={placeholder}
                size="xl"
                value={value ? [value] : []}
            />
        </Field>
    );
};
